'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("babel-polyfill");

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactRouterDom = require("react-router-dom");

var _es6Promise = _interopRequireDefault(require("es6-promise"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _reducer = require("./lib/reducer");

var _reduxPromiseMiddleware = _interopRequireDefault(require("redux-promise-middleware"));

var _objectFitImages = _interopRequireDefault(require("object-fit-images"));

var _history = require("history");

var _animationWrapper = _interopRequireDefault(require("./components/animation-wrapper"));

var _notFound = _interopRequireDefault(require("./components/not-found"));

var _customStyleLoader = _interopRequireDefault(require("./components/custom-style-loader"));

var _searchWithMapOpen = _interopRequireDefault(require("./components/search/lib/search-with-map-open"));

var _cookieBanner = _interopRequireDefault(require("./components/cookie-banner"));

var _config = _interopRequireDefault(require("./components/cookie-banner/config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

_es6Promise.default.polyfill(); // import components here


var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
var store = (0, _redux.createStore)(_reducer.farmSearch, composeEnhancers((0, _redux.applyMiddleware)((0, _reduxPromiseMiddleware.default)())));
window.dataLayer = window.dataLayer || [];
var customHistory = (0, _history.createBrowserHistory)();

if (document.getElementById('app')) {
  (0, _objectFitImages.default)();

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: store
  }, /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_customStyleLoader.default, null), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Router, {
    history: customHistory
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: '/404',
    component: _notFound.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/:language/map",
    component: _searchWithMapOpen.default
  }), /*#__PURE__*/_react.default.createElement(_animationWrapper.default, null), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    component: _notFound.default
  })), /*#__PURE__*/_react.default.createElement(_cookieBanner.default, {
    configs: _config.default
  }))))), document.getElementById('app'));
}


//////////////////
// WEBPACK FOOTER
// ./client/main.js
// module id = 337
// module chunks = 0